import { useUserMenuClose } from './context';

/**
 * Small text link for a card's slot — "View profile" under the company name.
 * Distinct from `UserMenuItem`, which is a full-width row in a section.
 */
export function UserMenuLink({
  label,
  onClick,
}: {
  label: string;
  onClick: () => void;
}) {
  const close = useUserMenuClose();

  return (
    <button
      type='button'
      className='text-xs text-primary hover:underline underline-offset-4 mt-0.5'
      onClick={() => {
        onClick();
        close();
      }}
    >
      {label}
    </button>
  );
}
